class Embedded {
  constructor(name, attributes) {
    this.name = name;
    this.tag = "script";
    this.attributes = {
      src: this.scriptUrl,
      append: `#embedded_${this.name}_app`
    };
    Object.keys(attributes).forEach(key => {
      this.attributes[key] = attributes[key];
    });
  }

  get complete() {
    try {
      for (let i in this.attributes) {
        if (this.attributes[i] === null) {
          throw Error();
        }
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  get tag_attributes() {
    return Object.keys(this.attributes)
      .map(v => {
        return `${v}="${this.attributes[v]}"`;
      })
      .join(" ");
  }

  get scriptUrl() {
    let prefix =
      process.env.VUE_APP_STATIC_HOST.replace(
        /^https:?/,
        window.location.protocol
      ).replace(/\/*$/, "/") +
      process.env.VUE_APP_STATIC_PATH.replace(/^\/+/, "").replace(
        /\/*$/,
        "/js"
      );
    return `${prefix}/embedded/${this.name}.js`;
  }

  get embeddedText() {
    return `<script type="text/javascript" ${this.tag_attributes}></script>`;
  }

  get element() {
    let el = document.createElement(this.tag);
    Object.keys(this.attributes).forEach(k => {
      el.setAttribute(k, this.attributes[k]);
    });
    return el;
  }
}

export default Embedded;
